/* eslint-disable no-undef */
export default function addTrackerToDOM(urlToSend) {
  const newImageElement = document.createElement('IMG');
  newImageElement.setAttribute('src', urlToSend);
  newImageElement.setAttribute('width', '1');
  newImageElement.setAttribute('height', '1');
  newImageElement.style.display = 'none';
  document.body.appendChild(newImageElement);
}
